import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { findAll, find } from '@fretadao/f-js-dom';

application.register(
  'ga-tracker',
  class extends Controller {
    connect() {
      this.#activeAdmin().forEach(item => {
        item.elements.forEach(element => {
          let eventName = typeof (item.eventName) === 'function' ? item.eventName(element) : item.eventName;
          if (!eventName) eventName = `${this.#systemName()}_${element.name}_${this.#normalizedPath()}`;

          this.#addTracker(item, element, eventName);
        });
      });

      this.#b2bAdmin().forEach(item => {
        item.elements.forEach(element => {
          this.#addTracker(item, element, item.eventName);
        });
      });

      this.#genericElements().forEach(item => {
        item.elements.forEach(element => {
          let eventName = item.eventName || `${this.#systemName()}_${element.name}_${this.#normalizedPath()}`;
          this.#addTracker(item, element, eventName);
        });
      });
    }

    addTag(event) {
      const attributes = JSON.parse(event.target.dataset.eventAttributes || '{}');

      gtag('event', event.target.dataset.eventName, attributes);
    }

    addConditionalTag(event) {
      const conditional = find(event.target.dataset.selector);
      const attributes = JSON.parse(event.target.dataset.eventAttributes || '{}');

      if (conditional?.checked) gtag('event', event.target.dataset.eventName, attributes);
    }

    #addTracker(item, element, eventName) {
      if (element.dataset.tracked) return;

      element.dataset.tracked = true;
      element.addEventListener(item.action, () => {
        gtag('event', eventName, { ...item.data, 'event_label': item.data.event_label(element) });
      });
    }

    #activeAdmin() {
      return [
        this.#downloadLinks(),
        this.#knowledgeArticleLinks(),
        this.#submitButtons()
      ];
    }

    #b2bAdmin() {
      return [
        this.#xlsxReports(),
      ]
    }

    #genericElements() {
      return [
        this.#submitButtons()
      ]
    }

    #downloadLinks() {
      return {
        elements: findAll('.download_links a'),
        action: 'click',
        eventName: 'download_default_report_link',
        data: {
          event_label: (element) => element.text
        }
      }
    }

    #normalizedPath() {
      const path = window.location.pathname;

      // to skip the first path, for B2B/BusOperator skips the agreement/company path
      let skipPaths = this.#systemName() === 'admin' ? 2 : 3;
      let splitedPath = path.split('/').slice(skipPaths);

      // remove the path only with ID
      splitedPath = splitedPath.filter((piece) => !/^\d+$/.test(piece));

      return splitedPath.join('_').toLowerCase().replaceAll(/[^\w]+/g, '_');
    }

    #systemName() {
      const adminSystems = ['admin', 'b2b', 'transportadores'];
      const paths = window.location.pathname.split('/');
      let system = paths[1];

      if (!adminSystems.includes(system)) system = 'site';

      return system;
    }

    #submitButtons() {
      return {
        elements: findAll('[type=submit]'),
        action: 'click',
        data: {
          event_label: (element) => element.title
        }
      }
    }

    #knowledgeArticleLinks() {
      return {
        elements: findAll('a.knowledge-article-link'),
        action: 'click',
        eventName: 'open_knowledge_article_link',
        data: {
          event_label: (element) => element.title
        }
      }
    }

    #xlsxReports() {
      return {
        elements: findAll('.xlsx_report'),
        action: 'click',
        eventName: 'download_b2b_xlsx_report',
        data: {
          event_label: (element) => element.text
        }
      }
    }
  }
);
